"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[5846],{

/***/ 75:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class SidecartStepper extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = [
    'copy',
    'progressBar',
    'step',
  ]
  static values = {
    currentItemsInCart: { type: Number, default: 0 },
    currentCartAmount: { type: Number, default: 0 },
    subscriptionState: { type: Boolean, default: true },
    bundleState: { type: Boolean, default: true },
    hideStepper: { type: Boolean, default: false },
  }

  PLACEHOLDERS = {
    remainingItemCount: {
      searchString: "__remainingItemCount__",
      replacedString: (step) => {
        const count = step.threshold - this.currentItemsInCartValue
        return(
          [
            `<span class="font-bold">${count}</span>`,
            count === 1 ? "coffee" : "coffees",
          ].join(' ')
        )
      }
    },
    remainingDollarAmount: {
      searchString: "__remainingDollarAmount__",
      replacedString: (step) => {
        return(
          `<span class="font-bold">$${step.dollarThreshold - this.currentCartAmountValue}</span>`
        )
      }
    },
  }

  #steps = []

  connect() {
    this.render()
  }

  currentItemsInCartValueChanged() {
    this.render()
  }

  currentCartAmountValueChanged() {
    this.render()
  }

  subscriptionStateValueChanged() {
    this.render()
  }

  bundleStateValueChanged() {
    this.render()
  }

  hideStepperValueChanged() {
    this.render()
  }

  render() {
    if (this.currentItemsInCartValue > 0 && !this.hideStepperValue) {
      this.element.classList.remove('hidden')
      this.initializeSteps()
      this.renderCopy()
      this.renderSteps()
      this.renderProgressBar()
    }

    // If no steps should render, hide the entire stepper
    const hasSteps = this.#steps.some(step => step.shouldRender)
    if (!hasSteps || this.hideStepperValue) {
      this.element.classList.add('hidden')
    }

    this.dispatch('stepperRendered', { detail: { steps: this.#steps }, prefix: null })
  }

  initializeSteps() {
    this.#steps = this.stepTargets.map((step) => {
      const stepDataset = step.dataset
      const subscriptionOnly = stepDataset.subscriptionOnly === 'true'
      const bundleOnly = stepDataset.bundleOnly === 'true'
      const threshold = parseInt(stepDataset.threshold)
      const dollarThreshold = parseFloat(stepDataset.dollarThreshold)
      const met = this.isStepMet(threshold, dollarThreshold)
      const shouldRender = this.stepShouldRender(subscriptionOnly, bundleOnly)

      // Pre-render copy for this step
      const renderedCopyWhenUnmet = this.renderStepCopy(stepDataset.copyWhenUnmet, { threshold, dollarThreshold })
      const renderedCopyWhenMet = this.renderStepCopy(stepDataset.copyWhenMet, { threshold, dollarThreshold })

      return {
        id: step.id,
        element: step,
        threshold: threshold,
        dollarThreshold: dollarThreshold,
        copyWhenUnmet: stepDataset.copyWhenUnmet,
        copyWhenMet: stepDataset.copyWhenMet,
        renderedCopyWhenUnmet,
        renderedCopyWhenMet,
        met,
        subscriptionOnly,
        shouldRender,
      }
    })
  }

  renderStepCopy(copy, step) {
    let renderedCopy = copy
    Object.keys(this.PLACEHOLDERS).forEach((key) => {
      const placeholder = this.PLACEHOLDERS[key]
      if (renderedCopy.includes(placeholder.searchString)) {
        renderedCopy = renderedCopy.replace(placeholder.searchString, placeholder.replacedString(step))
      }
    })
    return renderedCopy
  }

  isStepMet(itemThreshold, dollarThreshold) {
    const itemMet = itemThreshold > 0 && this.currentItemsInCartValue >= itemThreshold
    const dollarMet = dollarThreshold > 0 && this.currentCartAmountValue >= dollarThreshold

    return itemMet || dollarMet
  }

  stepShouldRender(subscriptionOnly, bundleOnly) {
    const satisfiesBundleOnly = !bundleOnly || this.bundleStateValue;
    const satisfiesSubscriptionOnly = !subscriptionOnly || this.subscriptionStateValue;

    return satisfiesBundleOnly && satisfiesSubscriptionOnly;
  }

  renderCopy() {
    const renderedSteps = this.#steps.filter(step => step.shouldRender)
    const nextUnmetStep = renderedSteps.find(step => !step.met)
    let copy = ''

    if (nextUnmetStep) {
      copy = nextUnmetStep.renderedCopyWhenUnmet
    } else if (renderedSteps.length > 0) {
      // All available steps met, use copyWhenMet of the highest step (by threshold or dollarThreshold)
      const maxStep = renderedSteps.reduce((a, b) => {
        const aVal = Math.max(Number(a.threshold) || 0, Number(a.dollarThreshold) || 0)
        const bVal = Math.max(Number(b.threshold) || 0, Number(b.dollarThreshold) || 0)
        return aVal > bVal ? a : b
      })
      copy = maxStep.renderedCopyWhenMet
    }

    this.copyTarget.innerHTML = copy
  }

  renderSteps() {
    this.#steps.forEach(step => {
      if (step.shouldRender) {
        this.showStep(step)
      } else {
        this.hideStep(step)
        return
      }

      const indicator = step.element.querySelector('.step-indicator')
      if (step.met) {
        this.markIndicatorAsMet(indicator)
      } else {
        this.markIndicatorAsUnmet(indicator)
      }
    })
  }

  showStep(step) {
    step.element.closest('.step-wrapper').classList.remove('hidden')
  }

  hideStep(step) {
    step.element.closest('.step-wrapper').classList.add('hidden')
  }

  markIndicatorAsMet(indicator) {
    indicator.classList.remove('border-cometeer-extra-cream')
    indicator.classList.add('border-cometeer-dark-blue')
    indicator.classList.remove('bg-white')
    indicator.classList.add('bg-cometeer-dark-blue')
    indicator.classList.remove('text-cometeer-dark-blue')
    indicator.classList.add('text-white')
    const stepIcon = indicator.querySelector('.step-icon')

    if (stepIcon) {
      stepIcon.classList.add('bg-white')
    }
  }

  markIndicatorAsUnmet(indicator) {
    indicator.classList.add('border-cometeer-extra-cream')
    indicator.classList.remove('border-cometeer-dark-blue')
    indicator.classList.add('bg-white')
    indicator.classList.remove('bg-cometeer-dark-blue')
    indicator.classList.add('text-cometeer-dark-blue')
    indicator.classList.remove('text-white')
    const stepIcon = indicator.querySelector('.step-icon')

    if (stepIcon) {
      stepIcon.classList.remove('bg-white')
    }
  }

  renderProgressBar() {
    const visibleSteps = this.#steps.filter(step => step.shouldRender)
    const progressBar = this.progressBarTarget

    if (visibleSteps.length === 0) {
      progressBar.style.width = '0%'
      return
    }

    // Always start with 0% (empty)
    const totalSegments = visibleSteps.length
    let progress = 0

    for (let i = 0; i < visibleSteps.length; i++) {
      const step = visibleSteps[i]
      if (step.met) {
        // Each met step fills its segment
        progress = ((i + 1) / totalSegments) * 100
      } else {
        // For unmet step, calculate proportional progress within this segment
        let segmentStart = (i / totalSegments) * 100
        let segmentEnd = ((i + 1) / totalSegments) * 100
        let percentWithinSegment = 0

        if (step.threshold > 0) {
          // Item-based step
          const prevThreshold = i === 0 ? 0 : visibleSteps[i - 1].threshold || 0
          const range = step.threshold - prevThreshold
          const current = Math.max(0, Math.min(this.currentItemsInCartValue - prevThreshold, range))
          percentWithinSegment = range > 0 ? current / range : 0
        } else if (step.dollarThreshold > 0) {
          // Dollar-based step
          const prevDollar = i === 0 ? 0 : visibleSteps[i - 1].dollarThreshold || 0
          const range = step.dollarThreshold - prevDollar
          const current = Math.max(0, Math.min(this.currentCartAmountValue - prevDollar, range))
          percentWithinSegment = range > 0 ? current / range : 0
        }

        progress = segmentStart + (segmentEnd - segmentStart) * percentWithinSegment
        break // Stop at the first unmet step
      }
    }

    const globalProgressPercentage = Math.min(progress, 100)
    progressBar.style.width = `${globalProgressPercentage}%`

    this.dispatch('stepperProgressBarRendered', { detail: { percentage: globalProgressPercentage }, prefix: null })
  }
}

Stimulus.register("sidecart-stepper", SidecartStepper)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(75)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);